import RevenueApi from "../api/service/revenue/RevenueApi";

export default class RevenueService {
    api;

    constructor() {
        this.api = new RevenueApi();
    }

    async getRevenueAnalysis({ startDate, endDate }) {
        return this.api.getRevenueAnalysis({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getRevenueShop({ startDate, endDate }) {
        return this.api.getRevenueShop({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getRevenueDay({ startDate, endDate }) {
        return this.api.getRevenueDay({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getRevenueTotal({ startDate, endDate }) {
        return this.api.getRevenueTotal({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getRevenueOrderList({ orderId, shopCode, shopName, deviceName, startDate, endDate, result, page, pageSize }) {
        return this.api
            .getRevenueOrderList({ orderId, shopCode, shopName, deviceName, startDate, endDate, result, page, pageSize })
            .then((res) => {
                if (res.resultCode === "0000") return res.result;
                throw new Error(res.result);
            });
    }

    async saveRevenueVoid(reqDto) {
        return this.api.saveRevenueVoid(reqDto).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getRevenueVoid({ startDate, endDate }) {
        return this.api.getRevenueVoid({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async uploadIndiaTransaction(reqDto) {
        return this.api.uploadIndiaTransaction(reqDto).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getIndiaReport(params) {
        return this.api.getIndiaReport(params).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getUsageDay({ startDate, endDate }) {
        return this.api.getUsageDay({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getUsageWeek({ startDate, endDate }) {
        return this.api.getUsageWeek({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getUsageHourWeek({ startDate, endDate }) {
        return this.api.getUsageHourWeek({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getUsageShop({ startDate, endDate }) {
        return this.api.getUsageShop({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async getUsageDevice({ startDate, endDate }) {
        return this.api.getUsageDevice({ startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }

    async generateRevenueCumulative() {
        return this.api.generateRevenueCumulative().then((res) => {
            if (res.resultCode === "0000") return res.result;
            throw new Error(res.result);
        });
    }
}
